/**
 * Zajišťuje, aby i na menších rozlišeních bylo modální okno responzivní, tzn. přizpůsobovalo se velikosti rozlišení.
 * @param browserSize Hodnota pro velikost šířky nebo výšky prohlížeče.
 * @param defaultSize Hodnota pro defaultní velikost šířky nebo výšky modálního okna.
 */
export const getFittableSize = (browserSize: number, defaultSize: number): number => {
    return browserSize < defaultSize ? browserSize * 0.8 : defaultSize;
};

/**
 * Určuje výchozí hodnotu pozice modálního okna.
 * @param browserWidth Šířka nebo výška prohlížeče.
 * @param alignSide Hodnota odsazení modálního okna od levého nebo horního okraje prohlížeče.
 * @param windowDimension Šířka nebo výška modálního okna.
 */
export const setInitialPosition = (browserWidth: number, alignSide: number, windowDimension: number): number => {
    return browserWidth * alignSide - (windowDimension / 2);
};

/**
 * Určuje maximální a minimální velikost modálního okna.
 * @param newSizeValue Hodnota nové šířky nebo velikosti modálního okna.
 * @param minSize Minimální hodnota šířky nebo velikosti modálního okna.
 * @param browserSize Hodnota pro velikost šířky nebo výšky prohlížeče.
 */
export const clampWindowDimension = (newSizeValue: number, minSize: number, browserSize: number): number => {
    if (newSizeValue > minSize && newSizeValue < browserSize) {
        return newSizeValue;
    }

    if (newSizeValue >= browserSize) {
        return browserSize;
    }

    return minSize;
};

/**
 * Určuje, zda-li je modální okno mimo hranice prohlížeče.
 * @param newLeft Nová hodnota odsazení modálního okna od levého okraje prohlížeče.
 * @param newTop Nová hodnota odsazení modálního okna od horního okraje prohlížeče
 * @param windowDimensionWidth Šířka modálního okna.
 * @param browserWidth Šířka prohlížeče.
 * @param browserHeight Výška prohlížeče.
 */
export const isWindowOutOfBounds = (newLeft: number, newTop: number, windowDimensionWidth: number, browserWidth: number, browserHeight: number): boolean => {
    const horizontalOffset = (windowDimensionWidth >> 1) + newLeft;
    return horizontalOffset < 0
        || horizontalOffset > browserWidth
        || newTop < 0
        || newTop + 16 > browserHeight;
};
